import { maxLengthParser, onlyNumbersParser } from '../../../lib/form/utils';
import { PREPAID_CARD_NUMBER_LENGTH } from '../../../pages/AddCard/vault-card.schema';

export const parseCardNumber = (value: string) => maxLengthParser(onlyNumbersParser(value), PREPAID_CARD_NUMBER_LENGTH);
export const formatCardNumber = (value: string) => (value.match(/[\d]{1,4}/g) || []).join(' ');
